import '@/styles/main.scss';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import vuetify from './plugins/vuetify';
import { firebaseApp } from '@/core/firebaseInit';
import Components from '@/core/components';
import auth from './core/auth';
import { useCouponTypesStore } from '@/store/useCouponTypes';
import 'cropperjs/dist/cropper.min.css';
// import { loadFonts } from './plugins/webfontloader'

// loadFonts()


const app = createApp(App);

app.config.errorHandler = (err, instance, info) => {
  const msg = err instanceof Error ? err.message : String(err);
  if (msg.includes('Cannot read properties of null')) {
    return;
  }
  console.error(`[Vue error] ${info}:`, err);
};

Components(app);

app.use(firebaseApp);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(vuetify);
auth(router);

router.isReady().then(() => {
  app.mount('#app');

  const couponTypesStore = useCouponTypesStore();
  couponTypesStore.fetchCouponTypes();
});
